const WizardServerError = ({ displayAt = '', fieldName = '', message = '', displayMessage = '' } = {}) => ({
  displayAt: String(displayAt),
  fieldName: String(fieldName),
  message: String(message),
  displayMessage: String(displayMessage),
});

export default WizardServerError;

export type WizardServerErrorProps = ReturnType<typeof WizardServerError>;
